<template>
  <a-drawer title="包含的账号"
    width="900px"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose">
    <div>
      <!-- <div class="table-operator">
        <a-button @click="handleAdd"
          type="primary"
          icon="plus">新增</a-button>
      </div> -->
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->
      <a-table class="table-div"
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        :rowSelection="null"
        @change="handleTableChange">

        <span slot="action"
          slot-scope="text, record,index">
          <a-switch v-model:checked="record.bindFlag"
            checked-children="绑定"
            :loading="switchLoading[index]"
            @change="bindFlagChange(record,index)"
            un-checked-children="解绑" />
        </span>
      </a-table>
      <mange-sources-account-modal ref="modalForm"
        @ok="modalFormOk"></mange-sources-account-modal>
    </div>
  </a-drawer>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin.js'
import { postAction, getAction } from '@/api/manage.js'
import mangeSourcesAccountModal from '../modules/mangeSourcesAccountModal'

const columns = [
  {
    title: '账号名称',
    align: "center",
    dataIndex: 'accountName',
    width: "150px",
  },
  {
    title: '用户id',
    align: "center",
    dataIndex: 'userid',
    width: "150px",
  },
  {
    title: '平台',
    align: "center",
    dataIndex: 'platform_dictText',
    width: "130px",
  },
  {
    title: '短信类型',
    align: "center",
    dataIndex: 'smsType_dictText',
    width: "150px",
  },

  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    // fixed: "right",
    align: "center",
  },
];
export default {
  components: {
    mangeSourcesAccountModal
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      visible: false,
      sourcesId: "",
      listData: [],
      columns: columns,
      disableMixinCreated: true,
      switchLoading: {},
      url: {
        list: "/base/busCommonMessageSourceAccountNew/listAccountBySourceId",
        bind: '/base/busCommonMessageSourceAccountNew/bind',//绑定
        unBind: '/base/busCommonMessageSourceAccountNew/unBind',//解绑
      }
    }
  },
  methods: {
    bindFlagChange(item, index) {
      console.log(item);
      const that = this;
      this.switchLoading[index] = true;
      let url = '';
      let params = {
        "accountId": item.id,
        "sourceId": this.sourcesId
      };
      console.log(typeof item.bindFlag);
      !item.bindFlag ? url = this.url.unBind : url = this.url.bind;
      postAction(url, params).then(res => {
        if (res.success) {
          that.switchLoading[index] = false;
          that.loadData(1);
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    handleAdd() {
      if (!this.sourcesId) {
        this.$message.error("找不到相应的sourcesId")
        return
      }
      this.$refs.modalForm.add({
        sourcesId: this.sourcesId
      });
      this.$refs.modalForm.title = "新增";
      this.$refs.modalForm.disableSubmit = false;
    },
    onClose() {
      this.visible = false
      this.initData()
    },
    open(record) {
      this.visible = true
      this.sourcesId = record.id;
    },
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error("请设置url.list属性!")
        return
      }
      //加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();//查询条件
      params.sourceId = this.sourcesId,
        this.loading = true;
      this.dataSource = []
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result;
          this.ipagination.total = res.result.total;
          this.pageRefresh++
        } else {
          this.$message.warning(res.message)
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false;
      })
    },
    initData() {
      this.listData = [];
      this.sourcesId = "";
    }
  },
  watch: {
    sourcesId(newVal) {
      if (newVal) {
        this.loadData(1);
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@assets/less/common.less';
.table-div {
  margin-top: 10px;
}
</style>